<template>
  <div class="member-card" data-type="countries">
    <div class="member-list"></div>
    <div>
      <div
        v-for="(item, i) in countries"
        :key="i"
        :ref="`scroller-${year}`"
        :data-order="`${item.type}-${item.order ? item.order : i}`"
        :class="{
          scroller: countries.length > 1,
          'scroller--single': countries.length === 1,
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
export default {
  props: {
    countries: {
      required: true,
    },
    year: {
      type: Number,
    },
  },
  mounted() {
    this.revealMembers();
  },
  methods: {
    revealMembers() {
      const { year } = this;
      const blanks = this.$refs[`scroller-${year}`];
      const firstOfMembers = [
        "member-first",
        "association-first",
        "accession-first",
      ];
      let fadeMeta = { duration: 0.3, ease: "power1.out" };
      let fadeIn = { ...fadeMeta, opacity: 1 };
      let fadeOut = { ...fadeMeta, opacity: 0 };

      blanks.forEach((blank, i, arr) => {
        ScrollTrigger.create({
          trigger: blank,
          // start: "top bottom",
          start: () => this.startPos(blank, i, arr),
          end: () => this.endPos(blank, i, arr),
          scroller: "#timeline",
          // markers: year === 2017 || year === 2018 ? true : false,
          id: `members-${i}-${year}`,
          onEnter: () => {
            let firstOfMember = blank.dataset.order;
            if (firstOfMembers.includes(firstOfMember)) {
              const type = firstOfMember.split("-")[0];
              gsap.to(`.member-type.${type}`, { ...fadeIn, yPercent: 100 });
            }
            gsap.to(`.member-${year}-${i}`, { ...fadeIn, yPercent: -200 });
            this.$emit("member-toggle", { action: "add", year, i });
          },
          onLeaveBack: () => {
            let firstOfMember = blank.dataset.order;
            if (firstOfMembers.includes(firstOfMember)) {
              const type = firstOfMember.split("-")[0];
              gsap.to(`.member-type.${type}`, { ...fadeOut, yPercent: -100 });
            }
            gsap.to(`.member-${year}-${i}`, { ...fadeOut, yPercent: 200 });
            this.$emit("member-toggle", { action: "remove", year, i });
          },
          onToggle: (self) => {
            const enter = self.direction === 1;
            const leave = self.direction === -1;
            const lastItem = i === arr.length - 1;
            const firstItem = i === 0;
            if (
              (self.isActive && firstItem && enter) ||
              (self.isActive && lastItem && leave)
            ) {
              this.$emit("globe-toggle", true);
              gsap.to(".globe-wrapper", fadeIn);
              gsap.to(".member-label-container", fadeIn);
            } else if (
              (!self.isActive && lastItem && enter) ||
              (!self.isActive && firstItem && leave)
            ) {
              this.$emit("globe-toggle", false);
              gsap.to(".globe-wrapper", {
                ...fadeMeta,
                opacity: leave && year === 1974 ? 0 : 0.3,
              });
              gsap.to(".member-label-container", { ...fadeMeta, opacity: 0.3 });
            }
          },
        });
      });
    },
    startPos(self, i, arr) {
      if (i === arr.length - 1) {
        if (self.offsetParent.parentElement.childElementCount === 1) {
          // console.log(this.year, self.offsetParent);
          return "top bottom";
        }
      }
      return "top bottom";
    },
    endPos(self, i, arr) {
      const margin = 0;
      if (i === arr.length - 1) {
        let offsetParentPrevSibling = self.offsetParent.previousElementSibling;
        let scroller = "bottom";
        if (offsetParentPrevSibling) {
          // If milestones exist
          if (offsetParentPrevSibling.children.length > 1) {
            scroller = `25%+=${
              offsetParentPrevSibling.lastChild.clientHeight + margin
            }px`;
          } else {
            scroller = `25%+=${
              offsetParentPrevSibling.firstChild.clientHeight + margin
            }px`;
          }
        } else {
          // only member map
          scroller =
            self.offsetParent.parentElement.offsetHeight * 0.75 - margin;
          // if (this.year === 1992)
          // console.log(
          //   self.offsetParent.parentElement.offsetHeight * 0.75,
          //   self.offsetParent.parentElement.offsetHeight * 0.75 - margin
          // );
        }
        return `bottom ${scroller}`;
      }
    },
  },
};
</script>

<style>
.member-card {
  margin-top: 40px;
  position: relative;
}
.member-list {
  width: 100%;
  height: calc((100vh - 60px) * 0.5) !important;
  position: sticky;
  top: 0;
}
.country-list--container {
  padding: 20px 0;
  box-sizing: border-box;
  display: flex;
  flex-flow: column;
  align-items: end;
}
.country-list--container > div {
  text-align: left;
  margin-bottom: 4px;
  font-size: 1rem;
  line-height: 1rem;
}
.scroller {
  width: 100%;
  height: 20vh;
}
.scroller--single {
  width: 100%;
  height: 50vh;
}
.country-label {
  color: #e3e3e3;
}
.mapboxgl-ctrl,
.mapboxgl-ctrl-attrib {
  display: none !important;
}
</style>
